export const FETCH_DASHBOARD_REQUEST = 'FETCH_DASHBOARD_REQUEST'
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS'
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE'
export const SET_DASHBOARD_PERIOD = 'SET_DASHBOARD_PERIOD'

const buildUrl = function (tenant, path, period, extraParams) {
  const url = tenant.getApiUrl(path)
  var result = url + '?period=' + encodeURIComponent(period || '30d')
  if (extraParams) {
    Object.keys(extraParams).forEach(function (key) {
      if (extraParams[key] !== undefined && extraParams[key] !== null && extraParams[key] !== '') {
        result += '&' + key + '=' + encodeURIComponent(extraParams[key])
      }
    })
  }
  return result
}

// ⬅ FIX — race condition across tenant switches. Dashboard.componentDidMount
// dispatches one of these on mount; TenantProvider.switchTenant() then
// unmounts/remounts the whole app tree, causing Dashboard to remount and
// dispatch a *second* fetch for the new tenant while the first (old
// tenant's) request may still be in flight — Elasticsearch on the backend
// is known to be slow/flaky, so the old request often resolves *after* the
// new one. dashboardReducer just overwrites `state.data` on every SUCCESS
// with no notion of which tenant/request it came from, so whichever
// response lands last wins — sometimes clobbering fresh data with the
// previous tenant's stale data. That's the "blinks, then shows the same
// old data" symptom; a hard refresh "fixes" it only because a refresh never
// has a leftover in-flight request to race against.
//
// Fix: track the most recent request per dashboard-fetch type with a
// monotonic id + AbortController. Abort the previous in-flight request when
// a new one starts, and drop any response that isn't from the latest
// request even if abort didn't take effect in time (e.g. request already
// past the point where AbortSignal is checked).
const dispatchFetch = function (path) {
  let latestRequestId = 0
  let activeController = null

  return function (tenant, period, extraParams) {
    return async function (dispatch) {
      const requestId = ++latestRequestId

      if (activeController) {
        activeController.abort()
      }
      const controller = new AbortController()
      activeController = controller

      dispatch({ type: FETCH_DASHBOARD_REQUEST, payload: { period: period || '30d' } })
      try {
        const token = localStorage.getItem('token')
        const response = await fetch(buildUrl(tenant, path, period, extraParams), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
          },
          signal: controller.signal
        })
        if (!response.ok) {
          throw new Error('HTTP error: ' + response.status)
        }
        const data = await response.json()

        // A newer request has since started — this response is stale, discard it.
        if (requestId !== latestRequestId) return

        dispatch({ type: FETCH_DASHBOARD_SUCCESS, payload: data })
      } catch (error) {
        if (error.name === 'AbortError') return
        if (requestId !== latestRequestId) return
        dispatch({ type: FETCH_DASHBOARD_FAILURE, payload: error.message })
      }
    }
  }
}

const fetchRecruiterDashboard = dispatchFetch('/api/v1/dashboard/recruiter')
const fetchAdminDashboard = dispatchFetch('/api/v1/dashboard/admin')
const fetchManagerDashboard = dispatchFetch('/api/v1/dashboard/manager')

const setDashboardPeriod = function (period) {
  return { type: SET_DASHBOARD_PERIOD, payload: period }
}

export {
  fetchRecruiterDashboard,
  fetchAdminDashboard,
  fetchManagerDashboard,
  setDashboardPeriod
}